import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { UseMutateFunction, useMutation } from 'react-query';
import { GroupsV2Api } from '../../../api-client';
import { getApiConfiguration } from '../../../common';

export const useAssignRoleToGroup = (
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, { groupId: string, roleId: string, bindings: string[], isCustom: boolean }>,
    'mutationFn'
    >,
): {
  assignRole: UseMutateFunction<AxiosResponse<void>, ErrorResponse, { groupId: string, roleId: string, bindings: string[], isCustom: boolean }>,
  isAssigning: boolean,
} => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const groupsV2Api = new GroupsV2Api(getApiConfiguration());

  const {
    mutate: assignRole,
    isLoading: isAssigning,
  } = useMutation(
    ({ groupId, roleId, bindings, isCustom = false }) => groupsV2Api.assignRole(tenantId, groupId, { roleId, bindings, isCustom }),
    options
  );

  return {
    assignRole,
    isAssigning,
  };
}
